import { Skeleton } from "@components/common/skeleton/skeleton";
import { Slide } from "@components/common/slider/slide/slide";
import { Slider } from "@components/common/slider/slider";
import { FunctionComponent } from "react";

export const NetworkConnectorSkeleton: FunctionComponent = () => {
    return (
        <div>
            <div className="grid grid-cols-1 gap-y-8">
                <div className="grid grid-cols-1 gap-y-3">
                    <div>
                        <div className="text-lg">
                            <Skeleton rounded="md">Lorem ipsum dolor</Skeleton>
                        </div>
                    </div>
                    <Slider slidesPerView={3} spaceBetween={20}>
                        <Slide>
                            <Skeleton width="100%" height={200} rounded="md" />
                        </Slide>
                        <Slide>
                            <Skeleton width="100%" height={200} rounded="md" />
                        </Slide>
                        <Slide>
                            <Skeleton width="100%" height={200} rounded="md" />
                        </Slide>
                    </Slider>
                </div>
            </div>
        </div>
    );
};
